import {Properties} from '@peachy/utility-kit-pure'
import {AnEvent} from '../../../event-kit'
import {LifeEventData} from '../../interfaces'
import {AccountType} from '../../../../domain/models/Account'


export class IndividualPolicyDocSendRequest extends AnEvent implements LifeEventData {
    constructor(from: Properties<IndividualPolicyDocSendRequest>) {
        super()
        Object.assign(this, from)
    }

    accountId: string
    accountType: AccountType
    lifeId: string
    cognitoId: string
    policyId: string
    subscriptionId: string
}
